{
    "DarkMode_Switch_Title": "Modalità scura",
    "NAME": "DarkMode",
    "DarkMode_SwitchLight_Title": "Modalità luce"
}